import type React from 'react';
import { Outlet } from 'react-router-dom';
import { useSmartPreloading } from '../components/LazyComponents';
import { UnauthenticatedLanding } from '../components/UnauthenticatedLanding';
import { useGuestSession } from '../contexts/GuestSessionContext';
import { useUser } from '../hooks';
import { useCalendarTypes } from '../hooks/useCalendarTypes';

const HomeLayout: React.FC = () => {
  const { isAuthenticated, idToken } = useUser();
  const { guestSession } = useGuestSession();

  useSmartPreloading();
  useCalendarTypes({ enabled: Boolean(isAuthenticated && idToken) });

  if (!(idToken || guestSession)) {
    return <UnauthenticatedLanding />;
  }

  return <Outlet />;
};

export default HomeLayout;
